import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCategoriesWithImages } from '../services/categorieTitreService';
import { asset } from '../services/api';
import '../styles/Categorie.css'; // On va créer ce fichier juste après

function Categorie() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesData = await getCategoriesWithImages();
        setCategories(categoriesData || []);
      } catch (error) {
        console.error("Erreur de chargement des catégories :", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="categorie-page">
      <h2 className="categorie-title">Nos Catégories</h2>
      <div className="category-list">
        {categories.length > 0 ? (
          categories.map((cat) => (
            <div
              key={cat.id}
              className="category-card"
              onClick={() => navigate(`/categorie/${cat.id}`)}
            >
              <img
                src={asset(cat.image)}
                alt={cat.categorie}
                className="category-img"
              />
              <p className="category-name">{cat.categorie}</p>
            </div>
          ))
        ) : (
          <p>Aucune catégorie disponible</p>
        )}
      </div>
    </div>
  );
}

export default Categorie;
